import { render } from "./ImportTab.vue?vue&type=template&id=152bbe9f"
import script from "./ImportTab.vue?vue&type=script&lang=js"
export * from "./ImportTab.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__